import { useQuery } from '@tanstack/react-query';
import { getFacturacionPorDia } from './dashboard-service';
import { dashboardKeys } from './keys';

/** Daily billing projection; changing the selected day uses a separate query cache entry. */
export function useFacturacionPorDia(dia: number) {
  return useQuery({
    queryKey: dashboardKeys.facturacionPorDia(dia),
    queryFn: () => getFacturacionPorDia(dia),
    staleTime: 60_000,
  });
}
